exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "th { white-space:nowrap; }\r\ntd { vertical-align:top; }\r\ntd a { display:block; }\r\ntd:last-child { white-space:nowrap; }\r\ntd:last-child a { display: inline; }\r\n.section-head h5 {\r\n    margin: 0 0 1rem 0;\r\n}\r\n.watch-tutorial {\r\n    margin-top: 15px !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-invoices/invoices-list/invoices-list.component.css
// module id = ../../../../../src/app/mnt-invoices/invoices-list/invoices-list.component.css
// module chunks = common